import React from "react"
import propTypes from "prop-types"

import Link from "../utils/link"
import useClickOutside from "../hooks/useClickOutside"

import Cart from "./HeaderIcons/Cart"
import CartClose from "../assets/images/Icons/cart-close.svg"
import CartPlus from "../assets/images/Icons/cart-plus.svg"
import CartMinus from "../assets/images/Icons/cart-minus.svg"
import "./CartPopup.scss"

const CartPopup = ({ setIsCartOpen, checkout, updateQuantityInCart }) => {
  const clickRef = React.useRef()

  useClickOutside(clickRef, () => {
    setIsCartOpen(false)
  })

  return (
    <div className="cart">
      <div className="cart__container">
        <div
          className="cart__icon"
          onClick={() => {
            setIsCartOpen(false)
          }}
        >
          <Cart />
        </div>
        <div className="cart__popup" ref={clickRef}>
          <div className="cart__popup__triangle" />
          <div className="cart__popup__box">
            <p className="cart__popup__box__title">your shopping cart</p>

            <img
              src={CartClose}
              className="cart__popup__box__close"
              onClick={() => {
                setIsCartOpen(false)
              }}
            />

            <div className="cart__popup__box__list">
              {checkout.lineItems.length === 0 ? (
                <div className="cart__empty">Cart Empty</div>
              ) : (
                checkout.lineItems.map((item, index) => {
                  return (
                    <div className="cart__popup__box__list__item" key={index}>
                      <div
                        className="cart__popup__box__list__item__image"
                        style={{
                          backgroundImage: `url(${item.variant.image.src})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      />

                      <div className="cart__popup__box__list__item__details">
                        <h1 className="cart__popup__box__list__item__details__name">
                          {item.title}
                          <br />
                          {item.variant.title !== 'Default Title' && item.variant?.title}
                        </h1>

                        <div className="cart__popup__box__list__item__details__quantity">
                          <img
                            src={CartMinus}
                            className="cart__popup__box__list__item__details__quantity__plus"
                            onClick={() => {
                              updateQuantityInCart(item.id, item.quantity - 1)
                            }}
                          />

                          <h1 className="cart__popup__box__list__item__details__quantity__count">
                            {item.quantity}
                          </h1>

                          <img
                            src={CartPlus}
                            className="cart__popup__box__list__item__details__quantity__plus"
                            onClick={() => {
                              updateQuantityInCart(item.id, item.quantity + 1)
                            }}
                          />

                          <h1 className="cart__popup__box__list__item__details__quantity__label">
                            qty
                          </h1>
                        </div>
                      </div>
                    </div>
                  )
                })
              )}
            </div>

            <h1 className="cart__popup__box__pricing">
              <span className="cart__popup__box__pricing__title">total</span>
              <br />${checkout.totalPrice} AUD
            </h1>

            {checkout.lineItems.length > 0 && (
              <Link to={checkout.webUrl} className="cart__popup__box__checkout">
                Checkout
              </Link>
            )}

            <Link
              to="/shop"
              className="cart__popup__box--shop"
              onClick={() => {
                setIsCartOpen(false)
              }}
            >
              keep shopping
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

CartPopup.propTypes = {
  setIsCartOpen: propTypes.func.isRequired,
  checkout: propTypes.object.isRequired,
  updateQuantityInCart: propTypes.func.isRequired,
}

export default CartPopup
